import { GET_NOTES_REQUEST, GET_NOTES_FAIL, GET_NOTES_SUCCESS } from "../constants/notes";
import axios from "axios";
import { baseUrl } from "./baseUrl";

export const getNotes = (patient) => async (dispatch) => {
    try {
        dispatch({
            type: GET_NOTES_REQUEST,
        });

        const config = {
            headers: {
                "Content-Type": "Application/json",
                "Authorization": "Bearer " + window.atob(JSON.parse(localStorage.getItem('md_btn_mi_sas'))),
            },
        };
        const { data } = await axios.get(
            `${baseUrl}/doctors_note?patient=${patient}`,
            config
        );

        dispatch({
            type: GET_NOTES_SUCCESS,
            payload: data,
        });

    } catch (err) {
        let message =
            err.response && err.response.data.errors
                ? err.response.data.errors
                : err.message;
        dispatch({
            type: GET_NOTES_FAIL,
            payload: message,
        });

    }
};


